import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserControls from 'flarum/forum/utils/UserControls';
import Button from 'flarum/common/components/Button';
export default function () {
  extend(UserControls, 'moderationControls', (items, user) => {
    const fofTerms = app.forum.attribute('fof-terms');
    if (fofTerms != null && fofTerms.canSeeUserPoliciesState) {
      items.add('fof-terms.state', m(Button, {
        icon: "fas fa-paperclip",
        onclick: () => {
          // Lazy load the modal component to reduce initial bundle size
          app.modal.show(() => import(/* webpackChunkName: 'forum/components/UserPoliciesStateModal', webpackMode: 'lazy-once' */ './components/UserPoliciesStateModal'), {
            user
          });
        }
      }, app.translator.trans('fof-terms.forum.user_controls.state_button')));
    }
  });
}flarum.reg.addChunkModule('329', '915', 'fof-terms', 'forum/components/UserPoliciesStateModal');